module.exports = __webpack_public_path__ + "img/logo_jsgrow.85b526b4.png";